import { __decorate } from "tslib";
import DateFilter from '@/components/DateFilter.vue';
import StatusBadge from '@/components/StatusBadge.vue';
import TeamFilter from "@/components/TeamFilter.vue";
import Avatar from "@/components/Avatar.vue";
import MediaViewModal from "@/components/MediaViewModal.vue";
import PerPage from "@/components/PerPage.vue";
import CustomerCard from "@/components/CustomerCard.vue";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ModalMixin from '@/mixins/modal-mixin';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import FilePreview from '@/components/FilePreview.vue';
import { debounce } from 'lodash';
import MediaItemsList from "@/components/Media/MediaItemsList.vue";
import ReportCard from "@/Pages/Reports/ReportCard.vue";
import SortDropdownComponent from '@/components/SortDropDownComponent.vue';
let CompanyMedia = class CompanyMedia extends Mixins(ModalMixin) {
    searchQuery = null;
    userFiler = [];
    dates = null;
    currentQuerySize = 0;
    currentMonthSize = 0;
    totalUsedSize = 0;
    currentPage = 1;
    perPage = 10;
    totalRows = 0;
    tags = ['Documents', 'Images', 'Archive', 'Others'];
    tagsQuery = [];
    sortOptions = [
        {
            text: 'Name',
            value: 'label'
        },
        {
            text: 'Upload date',
            value: 'createdAt'
        },
        {
            text: 'Size',
            value: 'size'
        }
    ];
    sort = {
        sortBy: 'createdAt',
        sortOrder: 'descending',
    };
    fetchMedia;
    fetchMediaLogs;
    getCustomer;
    removeMedia;
    clearMediaFromStore;
    findMediaInStore;
    areFilesLoading;
    get query() {
        const baseQuery = {};
        if (this.searchQuery) {
            baseQuery.$or = [
                { label: { $regex: this.searchQuery, $options: 'i' } },
                { filename: { $regex: this.searchQuery, $options: 'i' } },
            ];
        }
        if (this.userFiler.length) {
            baseQuery.userId = { $in: this.userFiler };
        }
        if (this.dates && this.dates.start) {
            baseQuery.createdAt = {
                $gte: this.dates.start,
                $lte: this.dates.end,
            };
        }
        if (this.tagsQuery.length) {
            // @ts-ignore
            baseQuery.tags = { $in: this.tagsQuery };
        }
        return baseQuery;
    }
    get paginationParams() {
        return {
            $limit: this.perPage,
            $skip: (this.currentPage - 1) * this.perPage,
        };
    }
    ;
    get sortParams() {
        return {
            $sort: {
                [this.sort.sortBy]: this.sort.sortOrder === 'ascending' ? 1 : -1,
            }
        };
    }
    ;
    get params() {
        return {
            query: {
                ...this.query,
                ...this.paginationParams,
                ...this.sortParams,
            },
        };
    }
    get files() {
        const localQuery = Object.assign({}, this.params.query, { $skip: 0 });
        return this.findMediaInStore({ query: localQuery }).data;
    }
    created() {
        this.fetchMediaLogs().then((data) => {
            this.totalUsedSize = (data[0] || {}).total || 0;
        });
        this.fetchMediaLogs({
            query: {
                createdAt: {
                    $gte: this.$moment().startOf('month').toDate(),
                },
            }
        }).then((data) => {
            this.currentMonthSize = (data[0] || {}).total || 0;
        });
    }
    onQueryChange() {
        debounce(() => {
            this.fetchData();
            this.currentPage = 1;
        }, 200)();
    }
    fetchData() {
        this.clearMediaFromStore();
        this.fetchMedia(this.params).then((data) => {
            this.totalRows = data.total;
        });
        this.fetchMediaLogs({ query: this.query }).then((data) => {
            this.currentQuerySize = (data[0] || {}).total || 0;
        });
    }
    reloadPage() {
        this.fetchData();
    }
    deleteItem(media) {
        this.removeMedia(media._id).then(() => {
            this.$toasted.global.success({
                message: this.$t('Item has been deleted')
            });
        });
    }
};
__decorate([
    Watch('query')
], CompanyMedia.prototype, "onQueryChange", null);
__decorate([
    Watch('currentPage'),
    Watch('perPage'),
    Watch('sort')
], CompanyMedia.prototype, "reloadPage", null);
CompanyMedia = __decorate([
    Component({
        components: {
            MediaItemsList,
            DateFilter,
            StatusBadge,
            TeamFilter,
            FilePreview,
            MediaViewModal,
            Avatar,
            PerPage,
            CustomerCard,
            ReportCard,
            SortDropdownComponent,
        },
        computed: {
            ...mapState('media', { areFilesLoading: 'isFindPending' }),
            ...mapGetters('media', { findMediaInStore: 'find' }),
        },
        methods: {
            ...mapActions('media', { fetchMedia: 'find', removeMedia: 'remove' }),
            ...mapActions('customers', { getCustomer: 'get' }),
            ...mapActions("media-summary", { 'fetchMediaLogs': 'find' }),
            ...mapMutations('media', {
                clearMediaFromStore: 'clearAll' // lets you do `this.clearTodos()` inside the component
            }),
        }
    })
], CompanyMedia);
export default CompanyMedia;
